import api from '../../../services/api';

const API_URL = '/api/v1/manager/bidSetup';

/**
 * @returns {Promise<ApiManager.GetAllManagerBidSetupsResponse>}
 */
// eslint-disable-next-line import/prefer-default-export
export const fetchAllBidSetups = () => api.get(API_URL);
